import React from 'react';
import Tab from 'react-bootstrap/Tab';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { InfoCollect, MainHeading, PrivacyTabContent, ReasonPersonalInfo, TabNavItem } from '../../components';
import './privacy.scss'
const Privacy = () => {
    const tabnavitems = [
        { eventKey: "disclose", title: "Information we collect and disclose" },
        { eventKey: "reason", title: "Reasons we share personal information" },
        { eventKey: "whoweare", title: "Who we are" },
        { eventKey: "personalinfo", title: "How we collect and protect personal information" },
        { eventKey: "howweuse", title: "How we use your information" },
        { eventKey: "definations", title: "Definitions" },
        { eventKey: "importantinfo", title: "Other important information" },
        { eventKey: "remarketingcookie", title: "Remarketing and cookie information" },
        { eventKey: "consent", title: "consent" },
        { eventKey: "children", title: "Children" },
        { eventKey: "linkofwebsites", title: "Links to or from other websites" },
        { eventKey: "addendum", title: "Privacy addendum for California residents" },
        { eventKey: "consumerrequets", title: "Consumer requests and questions" }

    ]
    const tabcontent = [
        {
            eventKey: 'disclose',
            heading: 'Information we collect and disclose',
            para1: 'Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share,and protect your personal information. Please read this notice carefully to understand what we do.',
            para2: 'The types of personal information we collect and share depend on the product or service you have with us. This information can include, but is not limited to:',
            lists: [
                { listname: 'Social Security number' },
                { listname: 'Insurance based credit score' },
                { listname: 'Transaction and loss history' },
                { listname: 'Insurance claim history' },
                { listname: 'Medical information' },
            ]
        },
        {
            eventKey: 'whoweare',
            heading: 'Who we are',
            para1: 'Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share,and protect your personal information. Please read this notice carefully to understand what we do.',
            para2: 'The types of personal information we collect and share depend on the product or service you have with us. This information can include, but is not limited to:',
            lists: [
                { listname: 'Social Security number' },
                { listname: 'Insurance based credit score' },
                { listname: 'Transaction and loss history' },
                { listname: 'Insurance claim history' },
                { listname: 'Medical information' },
            ]
        },
        {
            eventKey: 'personalinfo',
            heading: 'How we collect and protect personal information',
            para1: 'Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share,and protect your personal information. Please read this notice carefully to understand what we do.',
            para2: 'The types of personal information we collect and share depend on the product or service you have with us. This information can include, but is not limited to:',
            lists: [
                { listname: 'Social Security number' },
                { listname: 'Insurance based credit score' },
                { listname: 'Transaction and loss history' },
                { listname: 'Insurance claim history' },
                { listname: 'Medical information' },
            ]
        },
        {
            eventKey: 'howweuse',
            heading: 'How we use your information',
            para1: 'Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share,and protect your personal information. Please read this notice carefully to understand what we do.',
            para2: 'The types of personal information we collect and share depend on the product or service you have with us. This information can include, but is not limited to:',
            lists: [
                { listname: 'Social Security number' },
                { listname: 'Insurance based credit score' },
                { listname: 'Transaction and loss history' },
                { listname: 'Insurance claim history' },
                { listname: 'Medical information' },
            ]
        },
        {
            eventKey: 'definations',
            heading: 'Definitions',
            para1: 'Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share,and protect your personal information. Please read this notice carefully to understand what we do.',
            para2: 'The types of personal information we collect and share depend on the product or service you have with us. This information can include, but is not limited to:',
            lists: [
                { listname: 'Social Security number' },
                { listname: 'Insurance based credit score' },
                { listname: 'Transaction and loss history' },
                { listname: 'Insurance claim history' },
                { listname: 'Medical information' },
            ]
        },
        {
            eventKey: 'importantinfo',
            heading: 'Other important information',
            para1: 'Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share,and protect your personal information. Please read this notice carefully to understand what we do.',
            para2: 'The types of personal information we collect and share depend on the product or service you have with us. This information can include, but is not limited to:',
            lists: [
                { listname: 'Social Security number' },
                { listname: 'Insurance based credit score' },
                { listname: 'Transaction and loss history' },
                { listname: 'Insurance claim history' },
                { listname: 'Medical information' },
            ]
        },
        {
            eventKey: 'remarketingcookie',
            heading: 'Remarketing and cookie information',
            para1: 'Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share,and protect your personal information. Please read this notice carefully to understand what we do.',
            para2: 'The types of personal information we collect and share depend on the product or service you have with us. This information can include, but is not limited to:',
            lists: [
                { listname: 'Social Security number' },
                { listname: 'Insurance based credit score' },
                { listname: 'Transaction and loss history' },
                { listname: 'Insurance claim history' },
                { listname: 'Medical information' },
            ]
        },
        {
            eventKey: 'consent',
            heading: 'Consent',
            para1: 'Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share,and protect your personal information. Please read this notice carefully to understand what we do.',
            para2: 'The types of personal information we collect and share depend on the product or service you have with us. This information can include, but is not limited to:',
            lists: [
                { listname: 'Social Security number' },
                { listname: 'Insurance based credit score' },
                { listname: 'Transaction and loss history' },
                { listname: 'Insurance claim history' },
                { listname: 'Medical information' },
            ]
        },
        {
            eventKey: 'children',
            heading: 'Children',
            para1: 'Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share,and protect your personal information. Please read this notice carefully to understand what we do.',
            para2: 'The types of personal information we collect and share depend on the product or service you have with us. This information can include, but is not limited to:',
            lists: [
                { listname: 'Social Security number' },
                { listname: 'Insurance based credit score' },
                { listname: 'Transaction and loss history' },
                { listname: 'Insurance claim history' },
                { listname: 'Medical information' },
            ]
        },
        {
            eventKey: 'linkofwebsites',
            heading: 'Links to or from other websites',
            para1: 'Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share,and protect your personal information. Please read this notice carefully to understand what we do.',
            para2: 'The types of personal information we collect and share depend on the product or service you have with us. This information can include, but is not limited to:',
            lists: [
                { listname: 'Social Security number' },
                { listname: 'Insurance based credit score' },
                { listname: 'Transaction and loss history' },
                { listname: 'Insurance claim history' },
                { listname: 'Medical information' },
            ]
        },
        {
            eventKey: 'addendum',
            heading: 'Privacy addendum for California residents',
            para1: 'Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share,and protect your personal information. Please read this notice carefully to understand what we do.',
            para2: 'The types of personal information we collect and share depend on the product or service you have with us. This information can include, but is not limited to:',
            lists: [
                { listname: 'Social Security number' },
                { listname: 'Insurance based credit score' },
                { listname: 'Transaction and loss history' },
                { listname: 'Insurance claim history' },
                { listname: 'Medical information' },
            ]
        },
        {
            eventKey: 'consumerrequets',
            heading: 'Consumer requests and questions',
            para1: 'Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share,and protect your personal information. Please read this notice carefully to understand what we do.',
            para2: 'The types of personal information we collect and share depend on the product or service you have with us. This information can include, but is not limited to:',
            lists: [
                { listname: 'Social Security number' },
                { listname: 'Insurance based credit score' },
                { listname: 'Transaction and loss history' },
                { listname: 'Insurance claim history' },
                { listname: 'Medical information' },
            ]
        },
    ]
    return (
        <div className='privacy-wrapper'>
            <Container>
                <MainHeading title="Privacy policy" showshare={false} />
                <div className='common-heading'>
                    <h2>Protecting your personal information is important to us. Here’s how we handle your personal information.</h2>
                </div>
                <div className='privacy-tabs'>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="disclose">
                        <Row>
                            <Col md={4}>
                                <div className='tablist-container'>
                                    <div className='topics'>
                                        <h2>Topics</h2>
                                    </div>
                                    <Nav variant="pills" className="flex-column">
                                        <TabNavItem tabnavitems={tabnavitems} />
                                    </Nav>
                                </div>
                            </Col>
                            <Col md={8}>
                                <div className='tabs-content-wrapped'>
                                    <Tab.Content>
                                        {tabcontent.map((eachcontent) => (
                                            <PrivacyTabContent data={eachcontent} />
                                        ))}
                                        <ReasonPersonalInfo />
                                    </Tab.Content>
                                </div>
                            </Col>
                        </Row>
                    </Tab.Container>
                </div>
            </Container>
        </div>
    );
}

export default Privacy;
